var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FullCalendar',{staticClass:"full-calendar",attrs:{"defaultView":"dayGridMonth","plugins":_vm.plugins,"locale":_vm.locale,"events":_vm.events,"header":_vm.header},on:{"eventClick":_vm.eventClick,"eventRender":_vm.eventRender}})
}
var staticRenderFns = []

export { render, staticRenderFns }